import { copyToClipboard, envDomainMap, getFullName } from '../../../utils';
import moment from 'moment';
import CopyToClipboardIcon from '../../../icons/copyToClipboardIcon';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { styledDefaultColDef } from '../../../extras/cellRenderers';

const UrlGetter = (params) => {
  const [copied, setCopied] = React.useState(false);
  React.useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  let referralUrl =
    `https://${
      envDomainMap[process.env.REACT_APP_ENV || 'dev']
    }/auth/signup?referralCode=${params?.data?.referralCode}` || '';
  const utmParams = params?.data?.utmParams;
  if (utmParams) {
    Object.keys(utmParams)?.forEach((utmParam) => {
      if (utmParams[utmParam] && utmParams[utmParam].length > 0)
        referralUrl += `&${utmParam}=${utmParams[utmParam]}`;
    });
  }
  return (
    <Tooltip title={copied ? 'Copied' : 'Copy URL'}>
      <div
        onClick={() => {
          copyToClipboard(referralUrl);
          setCopied(true);
        }}
        className='cursor-pointer relative text-blue-500'
      >
        <span>{referralUrl}</span>
        <span className='float-right mt-3'>
          <CopyToClipboardIcon />
        </span>
      </div>
    </Tooltip>
  );
};

const EnrolmentNameGetter = (params) => {
  const name =
    params.data.referredUserDetail.firstName +
    ' ' +
    params.data.referredUserDetail.lastName;
  return (
    <div>
      <span>{name}</span>
    </div>
  );
};

const EnrolmentEmailGetter = (params) => {
  return <span>{params.data.referredUserDetail.email}</span>;
};

export const columnDefs = [
  { field: 'userId', hide: true },
  // user name
  {
    headerName: 'User Name',
    field: 'userName',
    headerTooltip: 'User Name',
    pinned: 'left',
    width: 200,
    filter: 'agTextColumnFilter',
    sortable: false,
    valueFormatter: (params) => {
      return getFullName(params.data.userDetail);
    },
    filterParams: {
      filterOptions: ['contains', 'equals'],
      valueGetter: (props) => getFullName(props.data.userDetail),
      debounceMs: 200,
    },
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = getFullName(nodeA?.data?.userDetail);
      const nameB = getFullName(nodeB?.data?.userDetail);
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    cellRenderer: 'nameGetter',
  },
  // url
  {
    headerName: 'Referral Url (click to copy)',
    field: 'referralUrl',
    headerTooltip: 'Referral Url',
    width: 250,
    filter: 'agTextColumnFilter',
    sortable: false,
    cellRenderer: UrlGetter,
  },
  // referral Amount
  {
    headerName: 'Refer and Earn Value',
    field: 'referralAmount',
    headerTooltip: 'Refer and Earn Value',
    width: 250,
    filter: 'agNumberColumnFilter',
    filterParams: {
      debounceMs: 200,
      valueGetter: (props) => props.data.referralAmount / 100,
      filterOptions: ['inRange', 'equals', 'greaterThan', 'lessThan'],
      suppressAndOrCondition: true,
    },
    valueFormatter: (params) => {
      return `${params.data.referralAmount / 100}`;
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const valueA1 = nodeA?.data?.referralAmount;
      const valueB1 = nodeB?.data?.referralAmount;
      const comparison = valueA1 - valueB1;
      return comparison;
    },
  },
  // email ID
  {
    headerName: 'Email ID',
    field: 'emailId',
    headerTooltip: 'Email ID',
    width: 250,
    sortable: false,
    valueFormatter: (params) => {
      return `${params.data?.userDetail?.email}`;
    },
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains', 'equals'],
      valueGetter: (props) => props.data?.userDetail?.email,
      debounceMs: 200,
      suppressAndOrCondition: true,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const emailA = nodeA.data?.userDetail.email || '';
      const emailB = nodeB.data?.userDetail.email || '';
      const comparison = emailA.localeCompare(emailB);
      return comparison;
    },
  },
  // no. of signups
  {
    headerName: 'No of Signups',
    field: 'noOfSignUps',
    headerTooltip: 'No of Signups',
    valueFormatter: (params) => {
      return `${params.data?.referredUsers?.length}`;
    },
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    filter: 'agNumberColumnFilter',
    filterParams: {
      debounceMs: 200,
      valueGetter: (props) => props.data?.referredUsers?.length,
      filterOptions: ['greaterThan', 'equals', 'lessThan'],
      suppressAndOrCondition: true,
    },
    sortable: false,
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const valueA1 = nodeA?.data?.referredUsers.length;
      const valueB1 = nodeB?.data?.referredUsers.length;
      const comparison = valueA1 - valueB1;
      return comparison;
    },
  },
  // no. of enrollments
  {
    headerName: 'No of Enrolments',
    field: 'noOfEnrollments',
    headerTooltip: 'No of Enrolments',
    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
    },
    sortable: false,
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    cellRenderer: 'enrollmentTable',
  },
  // created on
  {
    headerName: 'Created On',
    field: 'createdAt',
    headerTooltip: 'Created On',
    width: 250,
    valueFormatter: (params) => {
      return `${moment(params.data?.userDetail?.createdOn).format(
        'ddd, DD MMM YYYY, h:mm a'
      )}`;
    },
    filter: 'agDateColumnFilter',
    filterParams: {
      valueGetter: (props) => moment(props.data?.userDetail?.createdOn),
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('YYYY-MM-DD');
        const dateParts = dateAsString.split('-');
        const cellDate = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
      filterOptions: ['inRange'],
      suppressAndOrCondition: true,
    },
  },
  // user group
  {
    headerName: 'User Group',
    field: 'userGroup',
    headerTooltip: 'User Group',
    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
    },
    sortable: false,
    // floatingFilter: true,
  },
  // redeemed
  {
    headerName: 'Redeemed',
    field: 'redeemed',
    headerTooltip: 'Redeemed',
    valueFormatter: (params) => {
      return `${
        (params.data?.lifetimeRewards - params.data?.balance) / 100 || 0
      }`;
    },
    filter: 'agNumberColumnFilter',
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    sortable: false,
  },
  // gift cards
  {
    headerName: 'Gift Cards',
    field: 'giftCards',
    headerTooltip: 'Gift Cards',
    width: 200,
    menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    cellRenderer: 'giftCardTable',
    sortable: false,
  },
  // amount Earned
  {
    headerName: 'Amount Earned',
    field: 'lifetimeRewards',
    headerTooltip: 'Amount Earned',
    pinned: 'right',
    width: 250,
    valueFormatter: (params) => {
      return `${params.data?.lifetimeRewards / 100}`;
    },
    filter: 'agNumberColumnFilter',
    // floatingFilter: true,
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['inRange', 'equals', 'greaterThan', 'lessThan'],
    },
  },
];

export const enrollmentColumnDefs = [
  // name
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains', 'equals'],
      valueGetter: (props) => getFullName(props.data.referredUserDetail),
      debounceMs: 200,
      suppressAndOrCondition: true,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const nameA = getFullName(nodeA.data.referredUserDetail) || '';
      const nameB = getFullName(nodeB.data.referredUserDetail) || '';
      const comparison = nameA.localeCompare(nameB);
      return comparison;
    },
    cellRenderer: EnrolmentNameGetter,
  },
  // email
  {
    headerName: 'Email',
    field: 'email',
    filter: 'agTextColumnFilter',
    filterParams: {
      filterOptions: ['contains', 'equals'],
      valueGetter: (props) => props.data?.referredUserDetail?.email,
      debounceMs: 200,
      suppressAndOrCondition: true,
    },
    comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
      const emailA = nodeA.data?.referredUserDetail?.email || '';
      const emailB = nodeB.data?.referredUserDetail?.email || '';
      const comparison = emailA.localeCompare(emailB);
      return comparison;
    },
    cellRenderer: EnrolmentEmailGetter,
  },
  // signed up
  {
    headerName: 'Signed Up',
    field: 'signedUp',
    valueFormatter: (params) => {
      return `${moment(params?.data?.signupTS).format('DD MMM YYYY')}`;
    },
    filter: 'agDateColumnFilter',
    filterParams: {
      valueGetter: (props) => moment(props.data?.signupTS),
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('YYYY-MM-DD');
        const dateParts = dateAsString.split('-');
        const cellDate = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
      filterOptions: ['inRange', 'equals', 'lessThan', 'greaterThan'],
      suppressAndOrCondition: true,
    },
  },
  // Enrolled on
  {
    headerName: 'Enrolled On',
    field: 'enrolledOn',
    valueFormatter: (params) => {
      return params.data?.enrolledTS
        ? `${moment(params?.data?.enrolledTS).format('DD MMM YYYY')}`
        : '-/-/-';
    },
    filter: 'agDateColumnFilter',
    filterParams: {
      valueGetter: (props) => moment(props.data?.enrolledTS),
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        const dateAsString = moment(cellValue).format('YYYY-MM-DD');
        const dateParts = dateAsString.split('-');
        const cellDate = new Date(
          Number(dateParts[0]),
          Number(dateParts[1]) - 1,
          Number(dateParts[2])
        );
        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
          return 0;
        }
        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }
        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
        return 0;
      },
      filterOptions: ['inRange', 'equals', 'lessThan', 'greaterThan'],
      suppressAndOrCondition: true,
    },
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: true,
};
